import { component } from 'picoapp'
import $ from 'jquery'
import 'slick-carousel'

export default component(node => {
    const slider = node.querySelector('[data-product-carousel]')
    const sliderJquery = $(slider)
    const prev = node.querySelector('[data-prod-carousel-prev]')
    const next = node.querySelector('[data-prod-carousel-next]')

    const newSlick = sliderJquery.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: prev,
        nextArrow: next,
        infinite: false,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1.3,
                    arrows: false
                }
            }
        ]
    })
})